<template>
  <div class="bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <div class="space-y-2">
        <StackedField :label="t('plan')" :value="planSale.title" />
        <StackedField :label="t('price')" :value="price" />
        <StackedField :label="t('billing')" :value="billingLabel" />
        <StackedField v-if="planSale.orderReferenceId" :label="t('order')" :value="planSale.orderReferenceId" />
      </div>

      <div class="space-y-2">
        <StackedField :label="t('offer')" :value="planSale.category" />
        <StackedField :label="t('store')" :value="planSale.store?.salesChannel" />
        <StackedField v-if="sellerName" :label="t('seller')" :value="sellerName" />
      </div>

      <div class="space-y-2">
        <StackedField :label="t('start_date')" :value="planSale.date" />
        <StackedField v-if="planSale.cancellation?.date" :label="t('end_date')" :value="planSale.cancellation.date" />
        <StackedField :label="t('theoretical_end_date')" :value="planSale.expirationDate" />
        <StackedField :label="t('commitment')" :value="commitmentLabel" />
      </div>
    </div>

    <div v-if="planSale.membershipAgreement" class="mt-6 pt-4 border-t border-gray-200">
      <LinkField :label="t('membership_agreement')" :href="planSale.membershipAgreement" />
    </div>
  </div>
</template>

<script>
import { LinkField, StackedField, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "PlanSaleSummaryCard",

  components: { LinkField, StackedField },

  props: {
    planSale: {
      type: Object,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    price() {
      const price = formatPrice(this.planSale.price);
      return this.planSale.monthly ? this.t("price_per_month", { price }) : price;
    },

    billingLabel() {
      return this.planSale.monthly ? this.t("billing_monthly") : this.t("billing_annually");
    },

    sellerName() {
      return [this.planSale.seller?.firstName, this.planSale.seller?.lastName].filter(Boolean).join(" ");
    },

    commitmentLabel() {
      const type = this.planSale.cancellationPolicyType;
      if (!type) return null;

      return this.$t(`planSale.cancellationPolicyType.${type}`);
    },
  },
};
</script>

<i18n src="./PlanSaleSummaryCard.i18n.json"></i18n>
